import React, { useState, useEffect } from "react";

import { CircularProgress, Button } from "@mui/material"

import CFormat from "currency-formatter"

import { AiFillStar } from "react-icons/ai"

import porche from "../../Assets/engine.png";
import logo from '../../Assets/logo.png'

import { getProductsAPI } from "../../API/Store";
import { addProduct } from "../../GlobalStore/actions/productAction"
import { addItem, deleteItem } from "../../GlobalStore/actions/cartActions"
import { useSelector, useDispatch } from "react-redux"
import { ToastContainer, toast } from 'react-toastify';


import "./Fluxstore.scss";





const card = [
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },
  {
    img: porche,
    brand: "Flux Freedom",
    dollar: "$200000",
    shop: 'Add to Cart',

  },


];




const Fluxstore = () => {
  let dispute = useDispatch()

  let allProducts = useSelector((state) => state.ProductsData)

  const getProducts = async () => {
    let res = await getProductsAPI()
    if (res.error != null) {
      toast.error(res.error, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      dispute(addProduct(res.data.data))
    }

  }

  useEffect(() => {
    window.scrollTo(0, 0);
    dispute(addProduct(null))
    getProducts()
  }, [])

  return (
    <div className="flux_main">

      <div className="store_back">
        <div className="layer"></div>
        <img src={logo} />
        <div className="text">
          <div className="text_title">
            Flux Living
          </div>
          <div className="para">
            Browse a collection of fashion and Lifestyle accessories as luxurious as our vehicles.
          </div>
        </div>
      </div>
      <div className="flux_title">
        Merchandise
      </div>
      {
        allProducts ?
          allProducts.length <= 0 ?
            <>
              <div className="progress_box">
                <div className="no_data">NO Products Found</div>
              </div>
            </>
            :
            <>
              <div className="card_main">
                {allProducts.map((e) => {
                  return (
                    <>
                      <div className="card">
                        <img src={e.img} />
                        <div className="buy">
                          <div className="shop" onClick={() => dispute(addItem(e))}>
                            Add to Cart
                          </div>
                        </div>
                        <div className="btn_main">
                          <div>{CFormat.format(e.price, { code: "USD" })}</div>
                          <div>{e.name}</div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          :
          <>
            <div className="progress_box">
              <CircularProgress />
            </div>
          </>
      }
    </div>
  )
}

export default Fluxstore